import React from "react";
import GridContainer from "../../../../@jumbo/components/GridContainer";
import PageContainer from "../../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import UpdateUserContainer from "@jumbo/Dashboards/Users/UpdateUserContainer";
import AccessCheck from "@jumbo/Dashboards/Users/UpdateUserContainer/AccessCheck";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.usersPage"} />, link: "/users" },
  { label: <IntlMessages id={"pages.updateUserPage"} />, isActive: true },
];

const UpdateUser = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.updateUserPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.updateUserPage.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <UpdateUserContainer />
            <AccessCheck />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default UpdateUser;
